import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { UserManagementService } from '../user-management.service';
import * as moment from 'moment';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  column = [{
    field: 'DATE',
    header: 'วันที่'
  }, {
    field: 'DETAIL',
    header: 'รายละเอียด'
  }]

  allDetail = [];
  type: string;
  user_id: string;
  title: string;
  body;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userManagementService: UserManagementService,
    private gobalFunctionService: GobalFunctionService,
  ) { }

  ngOnInit(): void {
    this.user_id = new URL(location.href).searchParams.get('user_id');
    // console.log(this.user_id);

    this.route.params.pipe(
      first(),
      switchMap(params => {
        this.type = params['type'];
        this.body = {
          USER_ID: this.user_id,
          TYPE: this.type
        }

        switch (this.type) {
          case 'course': {
            this.title = `ประวัติคอร์สเรียน`;
            this.gobalFunctionService.setTitle(this.title);
            return this.userManagementService.getLogsHistoryByUser(this.body);
          }
          case 'measure': {
            this.title = `ประวัติแบบทดสอบ`;
            this.gobalFunctionService.setTitle(this.title);
            return this.userManagementService.getLogsHistoryByUser(this.body);
          }
          case 'activity': {
            this.title = `ประวัติกิจกรรม`;
            this.gobalFunctionService.setTitle(this.title);
            return this.userManagementService.getLogsHistoryByUser(this.body);
          }
          case 'research': {
            this.title = `ประวัติวิจัย`;
            this.gobalFunctionService.setTitle(this.title);
            return this.userManagementService.getLogsHistoryByUser(this.body);
          }
          case 'payment': {
            this.title = `ประวัติ Payment`;
            this.gobalFunctionService.setTitle(this.title);
            return this.userManagementService.getLogsHistoryByUser(this.body);
          }
        }
      }),
      map(res => {
        this.allDetail = res.result;
        // console.log(this.allDetail);
      }),
      catchError((err) => {
        alert(err);
        return of(false)
      })
    ).subscribe();

  }

}